import BossModel from "@/models/BossModel";

export default class TelephoneNumber extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'customer/telephone-number';

    /**
     *
     * @type {string}
     */
    static entity = 'customerTelephoneNumbers';

    static fields() {
        return {
            id: this.number(null).nullable(),
            customer_id: this.number(null),
            telephone_number: this.attr(null),
            label: this.attr(null).nullable(),
            is_default: this.boolean(false),
        }
    }
}
